import { render, staticRenderFns } from "./VerDatosAcceso.vue?vue&type=template&id=63b94bc3&scoped=true"
import script from "./VerDatosAcceso.vue?vue&type=script&lang=js"
export * from "./VerDatosAcceso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b94bc3",
  null
  
)

export default component.exports